"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BearWorkspaceDateFilterConfigsQuery = void 0;
var tslib_1 = require("tslib");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var DateFilterConfigConverter_1 = require("../../../convertors/fromBackend/DateFilterConfigConverter");
var sdk_backend_base_1 = require("@gooddata/sdk-backend-base");
var BearWorkspaceDateFilterConfigsQuery = /** @class */ (function () {
    function BearWorkspaceDateFilterConfigsQuery(authCall, workspace) {
        this.authCall = authCall;
        this.workspace = workspace;
    }
    BearWorkspaceDateFilterConfigsQuery.prototype.withLimit = function (limit) {
        ts_invariant_1.default(limit > 0, "limit must be a positive number, got: " + limit);
        this.limit = limit;
        return this;
    };
    BearWorkspaceDateFilterConfigsQuery.prototype.withOffset = function (offset) {
        this.offset = offset;
        return this;
    };
    BearWorkspaceDateFilterConfigsQuery.prototype.query = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.queryWorker()];
            });
        });
    };
    BearWorkspaceDateFilterConfigsQuery.prototype.queryWorker = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, sdk_backend_base_1.ServerPaging.for(function (_a) {
                        var limit = _a.limit, offset = _a.offset;
                        return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var data, items, totalCount;
                            var _this = this;
                            return tslib_1.__generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0: return [4 /*yield*/, this.authCall(function (sdk) {
                                            return sdk.md.getObjectsByQueryWithPaging(_this.workspace, {
                                                offset: offset,
                                                limit: limit,
                                                category: "dateFilterConfig",
                                                getTotalCount: true,
                                            });
                                        })];
                                    case 1:
                                        data = _b.sent();
                                        items = data.items, totalCount = data.paging.totalCount;
                                        return [2 /*return*/, {
                                                items: items.map(DateFilterConfigConverter_1.convertDateFilterConfig),
                                                totalCount: totalCount,
                                            }];
                                }
                            });
                        });
                    }, this.limit, this.offset)];
            });
        });
    };
    return BearWorkspaceDateFilterConfigsQuery;
}());
exports.BearWorkspaceDateFilterConfigsQuery = BearWorkspaceDateFilterConfigsQuery;
//# sourceMappingURL=index.js.map